import * as React from 'react';
const IconNavHome = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    style={{ width: '26px', height: '24px' }}
    width="26"
    height="24"
    viewBox="0 0 41 36"
    fill="none"
    {...props}
  >
    <path
      d="M25.5357 22.536H15.0552V35.964C14.8509 35.964 14.7105 35.988 14.5701 35.988C11.6978 35.988 8.82559 36 5.96611 35.988C3.00451 36.072 0.451398 34.032 0.0556664 31.272C0.00460423 30.948 -0.00816126 30.624 0.00460428 30.3C0.00460428 26.208 0.00460428 22.116 0.00460428 18.024C-0.0209268 17.424 0.24715 16.836 0.706709 16.428C6.79587 10.716 10.2043 7.52397 16.2679 1.79997C17.5391 0.6 18.387 0 20.3018 0C22.2166 0 23.4932 1.008 24.1315 1.608C30.2079 7.32 33.8205 10.716 39.9097 16.428C40.382 16.836 40.6373 17.424 40.6245 18.024C40.6118 22.2 40.6245 26.376 40.6118 30.552C40.6118 33.204 38.5821 35.472 35.8119 35.928C35.4673 35.976 35.1226 36 34.7779 36C31.8546 36 28.9313 36 26.008 36C25.8803 36 25.7655 35.988 25.574 35.976V22.548L25.5357 22.536Z"
      fill="white"
    />
  </svg>
);
export default IconNavHome;
